import axios from 'axios';
import {
  EDIT_ENTITY_NAME_API_URL,
  get_request_config
} from '@/utils/system_constants/constant';

export async function update_entity_name({ entity_id, name }) {
  const normalized_entity_id = Number(entity_id || 0);
  const normalized_name = String(name || '').trim();

  if (!normalized_entity_id) {
    const missing_entity_id_result = {
      status: 'error',
      message: 'This record is missing an entity id.'
    };
    return missing_entity_id_result;
  }

  if (!normalized_name) {
    const missing_name_result = {
      status: 'error',
      message: 'Name is required.'
    };
    return missing_name_result;
  }

  const response = await axios.post(
    EDIT_ENTITY_NAME_API_URL,
    {
      entity_id: normalized_entity_id,
      name: normalized_name
    },
    get_request_config()
  );

  return response?.data || {};
}
